import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const NavigationItem = ({ title, link = '', picto, itemClass, id, onClick, active }) => {
  const anchorClasses = ['main-nav__item', active ? '' : 'main-nav__item--inactive', itemClass]
    .join(' ')
    .trim();
  return (
    <Link className={anchorClasses} onClick={onClick} to={link} id={id}>
      <div className="main-nav__item__picto">
        {!active && <div className="main-nav__item__picto--inactive" />}
        {picto}
      </div>
      <div className="main-nav__label-wrapper">
        <span className={active ? 'main-nav__item__title' : 'main-nav__item__title--inactive'}>
          {title}
        </span>
      </div>
    </Link>
  );
};

NavigationItem.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  link: PropTypes.string,
  picto: PropTypes.object,
  itemClass: PropTypes.string,
  onClick: PropTypes.func,
  active: PropTypes.bool,
};

export default NavigationItem;
